import { Component, OnInit,Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CaptchaService } from 'src/app/components/layout/service/captcha.service';
import { ModErrorComponent } from '../../../layout/modals/mod-error/mod-error.component';

@Component({
  selector: 'app-personal-form-access',
  templateUrl: './personal-form-access.component.html',
  styleUrls: ['./personal-form-access.component.css']
})
export class PersonalFormAccessComponent implements OnInit {
  @Input() publicJwt: string;

  accessPage: boolean = false;
  key:string;
  Request: any;
  personalForm: UntypedFormGroup;
  publicJWT: string;
  submited = false;
  email:any;
  qualificationDummy:any;
  lang:string;
  qualificationDummyEnabled:any
  private numberPattern: any = /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/;

  constructor(private dataApi: CaptchaService,
              private _snackBar: MatSnackBar,
              private spinner: NgxSpinnerService,
              private formBuilder: UntypedFormBuilder,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) {
    this.publicJwt = this.route.snapshot.queryParamMap.get('form');
    this.key = environment.googleCaptchaProps.key;
  }

  ngOnInit() {
    this.personalForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      country:['', Validators.required],
      documentType:['', Validators.required],
      documentNumber:['', Validators.required],
      gender: ['', Validators.required],
      phone:['', [Validators.required, Validators.pattern(this.numberPattern)]],
      company:['', Validators.required],
      safetyOrganization:['', Validators.required],
      eCfullName:['', Validators.required],
      eCphone:['', [Validators.required, Validators.pattern(this.numberPattern)]],
      verificationCode: ['', Validators.required],
      confirm:[false, Validators.required]
  })
}

openDialog() {
  this.dialog.open(ModalConfirmComponent, {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
    if (accept) {
      this.personalForm.controls['confirm'].setValue(true);
    }
  });
}

  resolved(captchaResponse: string) {
    if(this.publicJwt===null || this.publicJwt===undefined){
      this.router.navigate(['/404']);
    }
    this.spinner.show("loading");
    this.dataApi.verifyCaptcha(captchaResponse, this.publicJwt).subscribe((data: any)=> {

      if(data.validToken && data.validToken==='false'){
        this.spinner.hide("loading");
        this.router.navigate(['/404']);
      }
      this.qualificationDummyEnabled = data.qualificationDummyEnabled;
      this.lang = sessionStorage.getItem('lang')
      if(data.qualificationDummy)
      {
        this.qualificationDummy=data.qualificationDummy
      }
      if(data.request){
        this.Request= data.request;
        let from = this.Request.from.split(" ")[0];
        let to = this.Request.to.split(" ")[0];
        this.Request.from=from;
        this.Request.to=to;
    }
    if(data.personalData){

       this.personalForm.controls.firstName.setValue(data.personalData.firstName);
       this.personalForm.controls.lastName.setValue(data.personalData.lastName);
       if(data.personalData.nationalId)
       {
         this.personalForm.controls.documentNumber.setValue(data.personalData.nationalId);
         this.personalForm.controls.documentType.setValue('nationalId');
      }else if (data.personalData.passportNumber)
      {
        this.personalForm.controls.documentNumber.setValue(data.personalData.passportNumber);
        this.personalForm.controls.documentType.setValue('PassportNumber');
      }
       this.personalForm.controls.country.setValue(data.personalData.nationality);
       this.email= data.personalData.email;

    }
      if(data.validate){
        this.accessPage=Boolean(data.validate);
     } //navegate --> no found.
    this.spinner.hide("loading");
    }, () =>{
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });

    });
  }

  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  onSubmit(){
    this.spinner.show("loading");
    this.submited=true;
    if(this.personalForm.controls['firstName'].hasError('required') || this.personalForm.controls['lastName'].hasError('required')){
      this.goTo('firstName');
      this.spinner.hide("loading");
      return;
    }
    if(this.personalForm.controls['country'].hasError('required') ||
      this.personalForm.controls['documentType'].hasError('required') ||
      this.personalForm.controls['documentNumber'].hasError('required') ||
      this.personalForm.controls['gender'].hasError('required')){

      this.goTo('country');
      this.spinner.hide("loading");
      return;
    }
    if(this.personalForm.controls['phone'].hasError('required') //|| this.personalForm.controls['company'].hasError('required')  || this.personalForm.controls['safetyOrganization'].hasError('required')
     || this.personalForm.controls['phone'].hasError('pattern')){
      this.goTo('phone');
      this.spinner.hide("loading");
      return;
    }
    if(this.personalForm.controls['eCfullName'].hasError('required') || this.personalForm.controls['eCphone'].hasError('required')
    || this.personalForm.controls['eCphone'].hasError('pattern')){
      this.goTo('eCfullName');
      this.spinner.hide("loading");
      return;
    }
    if(this.personalForm.controls['verificationCode'].hasError('required')){
      this.goTo('verificationCode');
      this.spinner.hide("loading");
      return;
    }
    if(this.personalForm.controls['confirm'].hasError('required')){
      this.goTo('confirm');
      this.spinner.hide("loading");
      return;
    }
    const AccessRequest = {
      firstName : String(this.personalForm.value.firstName),
      lastName: String(this.personalForm.value.lastName),
      email: String(this.email),
      gender: String(this.personalForm.value.gender),
      nationality:  String(this.personalForm.value.country),
      nationalId:  String(this.personalForm.value.documentNumber),
      passportNumber: String(this.personalForm.value.documentNumber),
      phoneNumber:  String(this.personalForm.value.phone),
      company: this.personalForm.value.company,
      safetyOrganization:  this.personalForm.value.safetyOrganization,
      emergencyContact: {
        fullName: String(this.personalForm.value.eCfullName),
        phone: String(this.personalForm.value.eCphone)
      },
      verificationCode:  this.personalForm.value.verificationCode
    }

    if(this.personalForm.value.documentType === 'nationalId')
    {
      Object.assign(AccessRequest, {nationalId: this.personalForm.value.documentNumber, passportNumber: ""});

    }
    else if (this.personalForm.value.documentType === 'PassportNumber'){
      Object.assign(AccessRequest, {passportNumber: this.personalForm.value.documentNumber, nationalId: ""});

    }
    
     this.dataApi.postFormPublic(AccessRequest, this.publicJwt).subscribe( (response)=>{

       this.spinner.hide("loading");
       if(response.sucess===true){
         this.router.navigate(['/form-confirmation/success']);
       } else{
         this.router.navigate(['/form-confirmation/fail']);
       }
     }, ()=>{
       this.spinner.hide("loading");
       this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
     })


  }

}
